export default {
  methods: {
    showError(err) {
      let text = err.message;
      if (err.response) {
        text = `${err.response.statusText} ${err.response.status}`
        if (err.response.data) {
          text += `: ${err.response.data.message || err.response.data}`;
        }
      }
      this.$store.dispatch("SHOW_SNACKBAR", {
        text,
        color: "error"
      });
    },
    editEntity(entity, resource, isNew = false) {
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    removeEntity(entity, resource) {
      this.$root.$confirm(`האם למחוק את ה${resource.name}?`).then(res => {
        if (!res) {
          return;
        }

        this.removing = true;
        this.$store
          .dispatch("REMOVE_ENTITY", {
            url: resource.endpoint,
            entityType: resource.entityType,
            id: entity._id
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: `${resource.name} נמחק/ה`,
              color: "success"
            });
          })
          .catch(err => {
            console.log(err.stack);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.removing = false;
          });
      });
    },
    heDate(d, showYear = false, showTime = false) {
      try {
        let date = new Date(d);
        let options = { weekday: "long", month: "long", day: "numeric" };
        if (showYear) {
          options['year'] = "numeric";
        }
        if (showTime) {
          options['hour'] = "numeric";
          options['minute'] = "numeric";
        }
        return new Intl.DateTimeFormat("he-IL", options).format(date);
      } catch (err) {
        return "שגיאת תאריך";
      }
    }
  },
  computed: {
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  }
}